import React, { useState } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import "../../stylesheets/passwordReset.css";

const PasswordField = ({ id, label, placeholder, value, onChange, onPaste, autoComplete = "new-password", describedBy, disabled, visibilityLabel }) => {
  const [hidden, setHidden] = useState(true);

  return (
    <div className="password-reset-field">
      <label htmlFor={id}>{label}</label>
      <div className="password-reset-input-wrap">
        <input
          id={id}
          name={id}
          type={hidden ? "password" : "text"}
          autoComplete={autoComplete}
          placeholder={placeholder}
          value={value}
          required
          disabled={disabled}
          aria-describedby={describedBy}
          onChange={(event) => onChange(event.target.value)}
          onPaste={onPaste}
        />
        <button
          type="button"
          className="password-reset-visibility"
          aria-label={`${hidden ? "Afficher" : "Masquer"} ${visibilityLabel}`}
          aria-controls={id}
          aria-pressed={!hidden}
          onClick={() => setHidden(!hidden)}
        >
          {hidden ? <VisibilityOutlinedIcon fontSize="small" /> : <VisibilityOffOutlinedIcon fontSize="small" />}
        </button>
      </div>
    </div>
  );
};

export default PasswordField;
